
    import Vue from 'vue';
    import { settingsHelper } from '@/store/modules/settings';
    import CompanyLogo from '@/components/Logo/CompanyLogo.vue';
    import CompanyBrand from '@/components/Logo/CompanyBrand.vue';
    import { SystemPagesEnum } from '@/util/signup';
    import signupHelper from '@/store/modules/signup/helper';
    import navigationHelper from '@/store/modules/navigation/helper';
    import BurgerMenu from '@/components/Layout/BurgerMenu.vue';
    const settingsHelpers = settingsHelper.mapGetters({ locale: 'locale' });
    const signupHelpers = navigationHelper.mapGetters({ page: 'page' });

    export default Vue.extend({
        name: 'AppHeader',
        components: {
            BurgerMenu,
            CompanyLogo,
            CompanyBrand
        },
        data() {
            return { small: false };
        },
        computed: {
            ...settingsHelpers,
            ...signupHelpers,
            noHeader() {
              try {
                return this.$store.state.settings.config.app.noHeader;
              } catch (error) {
                return false;                
              }
            },
            noBurgerMenu() {
                try {
                    return this.$store.state.settings.config.app.noBurgerMenu;
                } catch (error) {
                    return false;                
                }
            }
        },
        methods: {
            ...navigationHelper.mapActions({
                jumpToPage: 'jump',
                startover: 'firstPage',
            }),
            processPage(page: string) {
                switch (page) {
                    case 'welcome':
                        this.small = false;
                        break;
                    default: {
                        this.small = true;
                    }
                }
            },
        },
        watch: {
            page: {
                handler: 'processPage' as any,
                immediate: true,
            },
            locale(v) {
                // if (!!v.current) {
                //   this.$i18n.locale = v.current;
                // }
            },
            p(v) {
                this.jumpToPage(v);
            },
        },
    });
